import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/eu';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/ca';
import 'moment/locale/gl';
import i18n from 'i18next';
import CustomPaginationTable from './CustomPaginationTable';
import IconRegalo from '../../Icons/IconRegalo';
import useAPIError from '../../hooks/useAPIError';
import PuntosFilter from './PuntosFilter';
import { useAuthStore } from '../../store/AuthContext';
import { useAppStore } from '../../store/AppContext';
import NoData from '../../components/NoData';
import { PuntosTravelHelper } from './PuntosTravelHelper';
import { StylesSwapHelper } from '../../utils/StylesSwapHelper';
import { StorageHelper } from '../../utils/StorageHelper';
import Title from '../../components/Title';
import BotonVolverFlotante from '../../components/BotonVolverFlotante';
import { ErrorCodeConstants } from '../../utils/ErrorCodeConstants';
import { BackMappings } from '../../utils/BackMappings';

interface TravelData {
  fecha: string;
  concepto: string;
  importe: number;
  puntos: number;
}

const PuntosTravelEroski: FC = () => {
  const dataApp = useAppStore();
  const startComboMonths: string[] = [];
  const endComboMonths: string[] = [];

  const { t } = useTranslation();
  const [TravelData, setTravelData] = useState<TravelData[]>([]);
  const [totalElements, setTotalElements] = useState(0 as number);
  const [puntosUsuario, setPuntosUsuario] = useState(0 as number);
  const [load, setLoad] = useState(false as boolean);
  const indexMonth = moment().month() - 5;

  const [startDate, setStartDate] = useState(
    moment().month(indexMonth).locale(dataApp.lang).format('YYYYMM'),
  );

  // eslint-disable-next-line no-plusplus
  for (let i = indexMonth; i <= moment().month(); i++) {
    startComboMonths.push(
      `${moment()
        .month(i)
        .locale(dataApp.lang)
        .format('YYYYMM')},${moment()
        .month(i)
        .locale(dataApp.lang)
        .format('MMMM YYYY')}`,
    );
  }
  // eslint-disable-next-line no-plusplus
  for (let i = moment().month(); i >= indexMonth; i--) {
    endComboMonths.push(
      `${moment()
        .month(i)
        .locale(dataApp.lang)
        .format('YYYYMM')},${moment()
        .month(i)
        .locale(dataApp.lang)
        .format('MMMM YYYY')}`,
    );
  }
  const [endDate, setEndDate] = useState(
    moment().locale(dataApp.lang).format('YYYYMM'),
  );
  let end: string = moment().locale(dataApp.lang).format('MMMM YYYY');
  const [view, setView] = useState(false as boolean);
  const [backError, setBackError] = useState(false as boolean);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { addError, addErrorBack } = useAPIError();
  const dataUser = useAuthStore();
  const [firstCharge, setFirstCharge] = useState(true);

  const retrieveTravels = (param: any) => {
    PuntosTravelHelper.getCorrectTravelFunction(param)
      .then((response) => {
        if (response.data.error === true) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setView(true);
          setBackError(true);
          if (
            param === null ||
            response.data.errorCode ===
              ErrorCodeConstants.PUNTOSTRAVEL_BADWS_EXCEPTION
          )
            addErrorBack(response.data);
          else addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          setView(true);
          setBackError(false);
          if (typeof response.data.pojos !== 'undefined')
            setTravelData(response.data.pojos);
          if (typeof response.data.totalElements !== 'undefined')
            setTotalElements(response.data.totalElements);
          if (typeof response.data.puntosUsuario !== 'undefined')
            setPuntosUsuario(response.data.puntosUsuario);
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dataUser.user.token !== '') {
      if (!load) {
        setLoad(true);
        retrieveTravels(null);
      }
    }
  });

  const handleChangeStart = (date: string) => {
    PuntosTravelHelper.handleChangeStart(date);
    setStartDate(date);
  };
  const handleChangeEnd = (date: string) => {
    end = date;
    PuntosTravelHelper.handleChangeEnd(date);
    setEndDate(end);
  };

  const Enviar = (e: any) => {
    e.preventDefault();
    const data = {
      startDate,
      endDate,
    };
    retrieveTravels(data);
  };
  useEffect(() => {
    if (dataUser.user.token !== '') retrieveTravels(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return (
    <>
      <BotonVolverFlotante />
      {(() => {
        if (view) {
          const isApp = dataUser.user.isApp === 'true';
          const isEcommerceBot = StorageHelper.isEcommerceBot();

          StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);
          return (
            <>
              <section className="o-section--medium o-section--no-padding-top section--background--travel">
                <div className="container">
                  <div className="cabecera-seccion">
                    <Title
                      titleName={t('travel.title')}
                      titleValue={puntosUsuario}
                      numText={t('travel.enjoy')}
                      page="puntos-travel"
                      isLoad={view}
                    />

                    <div className="u-display-flex u-align-items-end">
                      {(() => {
                        if (view) {
                          return (
                            <div className="img logo-cabecera">
                              <img
                                src="../../assets/images/logo-travel.png"
                                alt="Imagen del logo Travel Club"
                              />
                            </div>
                          );
                        }
                        return <></>;
                      })()}

                      {(() => {
                        if (view && dataUser.user.isApp === 'false') {
                          return (
                            <div className="links-cabecera">
                              <div className="icon-link-block u-margin-bottom-small">
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <a
                                  href="https://www.travelclub.es/canjearptos/home.cfm"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="icon-link u-align-items-baseline"
                                >
                                  <div className="icon icon-medium icon--white">
                                    <IconRegalo />
                                  </div>
                                  <span className="u-font-small u-text-white u-text-decoration-underline">
                                    {t('travel.gifts')}
                                  </span>
                                </a>
                              </div>
                            </div>
                          );
                        }
                        return <></>;
                      })()}
                    </div>
                  </div>
                </div>
              </section>
              <section className="o-section--large travelPage">
                <div className="container-inner__small">
                  {(() => {
                    if (!backError) {
                      return (
                        <>
                          <form
                            className="u-display-flex u-justify-content-center u-margin-bottom-large u-font-small"
                            method=""
                          >
                            <div className="form-group u-margin-right-medium">
                              <div className="form-control-block has-icon datepicker-block" />
                              <PuntosFilter
                                id="start_select"
                                onChange={handleChangeStart}
                                months={startComboMonths}
                                tipo="inicio"
                              />
                            </div>

                            <div className="form-group u-margin-lef-medium">
                              <div className="form-control-block has-icon datepicker-block" />
                              <PuntosFilter
                                id="end_select"
                                onChange={handleChangeEnd}
                                months={endComboMonths}
                                tipo="fin"
                              />
                            </div>
                            <div className="form-group u-margin-lef-medium">
                              <div className="botonera">
                                {/* eslint-disable-next-line react/button-has-type */}
                                <button
                                  className="btn btn-default"
                                  onClick={(e) => {
                                    Enviar(e);
                                  }}
                                >
                                  {t('travel.accept')}
                                </button>
                              </div>
                            </div>
                          </form>
                          <p className="u-margin-top-medium u-margin-bottom-medium">
                            {t('travel.text')}
                          </p>
                        </>
                      );
                    }
                    return false;
                  })()}

                  {(() => {
                    if (!backError) {
                      return (
                        <CustomPaginationTable
                          data={TravelData}
                          total={totalElements}
                        />
                      );
                    }
                    return <NoData />;
                  })()}
                </div>
              </section>
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default PuntosTravelEroski;
